export const METHOD_NAMES = {
  SCRUM: { type: 'Scrum', days: 14 },
  KANBAN: { type: 'Kanban', days: 7 }
};
